<template>
  <span>You successfully created new user with your data</span>
</template>

<script>
export default {
  name: "created-user"
};
</script>
